/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});
    this.fetchRecommendations();
  }

  async fetchRecommendations() {
    if (!this.url) return;

    try {
      /* Try the curated complementary products first. If that returns no
         cards (product has none set up in Search & Discovery), fall back to
         Shopify's algorithmic "related" so the section is never empty. */
      let html = await this.fetchUrl(this.url);
      if (html !== null && !this.hasRecommendations(html) && this.fallbackUrl) {
        const fallbackHtml = await this.fetchUrl(this.fallbackUrl);
        if (fallbackHtml !== null) html = fallbackHtml;
      }
      if (html !== null) this.renderRecommendations(html);
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  async fetchUrl(url) {
    const response = await fetch(url);
    return response.ok ? await response.text() : null;
  }

  hasRecommendations(html) {
    const content = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('cart-recommendations')?.innerHTML;
    return !!(content && content.trim().length > 0);
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }

  get fallbackUrl() {
    return this.getAttribute('data-cart-recommendations-fallback-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;